import { render } from "./statistics.vue?vue&type=template&id=27ad1c6a&ts=true"
import script from "./statistics.vue?vue&type=script&lang=ts"
export * from "./statistics.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__